import { useEffect, useRef, useState } from 'react';
import { embedDashboard } from '@superset-ui/embedded-sdk';

interface SupersetDashboardProps {
    superset_url: string | undefined;
    dashboard_id: any;
    guest_token: string | undefined;
}

const SupersetDashboard = ({ superset_url, dashboard_id, guest_token }: SupersetDashboardProps) => {
    // TODO: create if clause where environment is checked
    const [isProd, setIsProd] = useState(false);
    const cutoff = 'services';
    const endIndex = superset_url.indexOf(cutoff) + cutoff.length;
    const superset_base_url = isProd ? superset_url : superset_url.substring(0, endIndex);

    useEffect(() => {
        const isDevOrStaging =
            superset_url.startsWith('http://localhost') ||
            superset_url.startsWith('https://development') ||
            superset_url.startsWith('https://staging');
        setIsProd(!isDevOrStaging);
    }, [superset_url]);

    const divRef = useRef<HTMLIFrameElement>(null);
    useEffect(() => {
        if (superset_url && dashboard_id && guest_token) {
            const initializeDashboard = async () => {
                try {
                    const mountPoint = document.getElementById('superset-container') as HTMLElement;
                    if (mountPoint) {
                        embedDashboard({
                            id: dashboard_id,
                            supersetDomain: superset_url,
                            mountPoint: mountPoint,
                            fetchGuestToken: async () => {
                                if (guest_token) {
                                    return Promise.resolve(guest_token);
                                } else {
                                    return Promise.reject('Guest token is undefined');
                                }
                            },
                            dashboardUiConfig: {
                                hideTitle: true,
                                hideChartControls: true,
                                hideTab: true,
                                filters: {
                                    expanded: false,
                                    visible: true,
                                },
                            },
                        });

                        // Ensure iframe is properly sized
                        const iframeSuperset = mountPoint.children[0] as HTMLIFrameElement;
                        if (iframeSuperset) {
                            iframeSuperset.style.width = '100%';
                            iframeSuperset.style.height = '100%';
                            iframeSuperset.style.boxShadow =
                                '0px 2px 4px -1px rgba(0, 0, 0, 0.20), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12';
                            iframeSuperset.style.border = 'none';
                            iframeSuperset.style.borderRadius = '5px';
                        }
                    } else {
                        console.error('Mount point element not found');
                    }
                } catch (error) {
                    console.error('Error initializing the dashboard:', error);
                }
            };

            initializeDashboard();
        }
    }, [superset_url, dashboard_id, guest_token]);

    return (
        <>
            <div
                ref={divRef}
                id="superset-container"
                style={{
                    width: '100%',
                    height: '100%',
                    scrollbarWidth: 'thin',
                }}
            />
        </>
    );
};

export default SupersetDashboard;
